export enum InquiryButtonTypeName {
    ASK = "ZAPYTAJ",
    OFFER = "ZAPYTAJ O OFERTĘ",
    PRICE = "ODKRYJ CENĘ",
    PRICES = "ODKRYJ CENY",
    RESERVATION = "Rezerwacja",
    ARRANGE_MEETING = "UMÓW SIĘ NA SPOTKANIE",
    INVESTMENT = "ZAPYTAJ DEWELOPERA O OFERTĘ",
    PROMOTIONS = "KONTAKT Z DEWELOPEREM",
    VENDOR = "ZAPYTAJ DEWELOPERA",
    NEGOTIATE = "NEGOCJUJ",
    DETAILS = "ZAPYTAJ O SZCZEGÓŁY",
    ASK_FOR_ALL = "ZAPYTAJ O WSZYSTKIE",
    SUBMIT_APPLICATION = "WYŚLIJ",
    SUBMIT_APPLICATION_EMAIL = "WYŚLIJ OFERTĘ NA MAILA",
    SUBMIT_PREMULTILEAD_EMAIL = "PRZEŚLIJ OFERTY NA MAILA",
    SHOW_SIMILAR_OFFERS = "ZOBACZ PODOBNE OFERTY",
    MOVE_TO_NEXT_STEP = "PRZEJDŹ DALEJ",
    ASK_FOR_FULL_OFFER = "ZAPYTAJ O PEŁNĄ OFERTĘ",
    SEE_DETAILS = "ZOBACZ SZCZEGÓŁY",
    SHOW_MORE = "ZOBACZ WIĘCEJ"
}
export enum InquiryButtonTypeName {
    ASK = "ZAPYTAJ",
    OFFER = "ZAPYTAJ O OFERTĘ",
    PRICE = "ODKRYJ CENĘ",
    PRICES = "ODKRYJ CENY",
    RESERVATION = "Rezerwacja",
    ARRANGE_MEETING = "UMÓW SIĘ NA SPOTKANIE",
    INVESTMENT = "ZAPYTAJ DEWELOPERA O OFERTĘ",
    PROMOTIONS = "KONTAKT Z DEWELOPEREM",
    VENDOR = "ZAPYTAJ DEWELOPERA",
    NEGOTIATE = "NEGOCJUJ",
    DETAILS = "ZAPYTAJ O SZCZEGÓŁY",
    ASK_FOR_ALL = "ZAPYTAJ O WSZYSTKIE",
    SUBMIT_APPLICATION = "WYŚLIJ",
    SUBMIT_APPLICATION_EMAIL = "WYŚLIJ OFERTĘ NA MAILA",
    SUBMIT_PREMULTILEAD_EMAIL = "PRZEŚLIJ OFERTY NA MAILA",
    SHOW_SIMILAR_OFFERS = "ZOBACZ PODOBNE OFERTY",
    MOVE_TO_NEXT_STEP = "PRZEJDŹ DALEJ",
    ASK_FOR_FULL_OFFER = "ZAPYTAJ O PEŁNĄ OFERTĘ",
    SEE_DETAILS = "ZOBACZ SZCZEGÓŁY",
    SHOW_MORE = "ZOBACZ WIĘCEJ"
}
